/**
 * Support at home's debts, for "Explain this" (owner, 22 Oct 2026): what a plan pays off, and the same plan tested
 * with the debts cleared (SupportAtHomeStrategyGenerator.generateDebtClearTwins names its group "<plan>-clear-debt").
 */
import type { SahConfigLike } from './sahPlanWords.ts';

type Row = { config?: Record<string, unknown> | null; snapshot?: unknown };

/** What the plan repays: its debt steps, and a downsize that repays a debt from the sale. */
export function sahDebtClearedBy(config: SahConfigLike | null | undefined): number {
    const c = (config || {}) as Record<string, any>;
    const steps: Record<string, any>[] = c.type === 'combination' && Array.isArray(c.steps) ? c.steps : [c];
    return steps.reduce((t, s) => {
        if (s?.type === 'debtRepayment') return t + (Number(s.repaymentAmount) || 0);
        if (s?.type === 'downsize' && s.downsizeDetails?.repayDebt) return t + (Number(s.downsizeDetails.debtRepayment) || 0);
        return t;
    }, 0);
}

/** The group a plan's twin carries: the same expression the generator uses. */
export function sahTwinGroupOf(config: Record<string, unknown> | null | undefined): string {
    const c = (config || {}) as Record<string, unknown>;
    return `${String(c.groupKey ?? c.name ?? c.type)}-clear-debt`;
}

/** The same plan with the debts paid off, among the evaluated rows; null when it was not tested. */
export function sahDebtTwinOf<T extends Row>(row: T | null | undefined, rows: T[]): T | null {
    if (!row?.config) return null;
    const key = sahTwinGroupOf(row.config);
    return rows.find((r) => r !== row && String(r.config?.groupKey ?? '') === key) ?? null;
}
